var map = {
	"./0-VeganRestaurant.png": 15,
	"./1-BusyBees.png": 16,
	"./2-EIKA.png": 17,
	"./3-BeeOrderly.png": 18,
	"./3-Commerce.jpeg": 19,
	"./4-BBQ.png": 20,
	"./5-Learning.jpg": 21,
	"./6-Bestflix.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;